import { helpLinks } from './help-links';

export class Metadata {
	"title" = "";
	"description" = "";
	"og:title" = "";
	"og:description" = "";
	"og:url" = "";
	"og:image" = "";
	"og:image:secure_url" = "";
	"og:image:alt" = "";
	"og:locale" = "";
	// "og:type": string = "";
	"og:site_name" = "";
	"twitter:title" = "";
	"twitter:description" = "";
	"twitter:image" = "";
	"twitter:card" = "";
	"twitter:site" = "";

	constructor() {
		this["og:locale"] = "en_US";
		// this["og:type"] = "website";
		this["og:site_name"] = "BindTuning App";
		this["twitter:card"] = "summary";
		this["twitter:site"] = "@bindskins";
	}
}

export const staticPages: Record<string, Metadata> = {
	"home" : Object.assign(new Metadata(), {
		"title": "Powerful provisioning. Effortless intranets. | BindTuning",
		"description": "Effortless onboarding, simplified processes, and powerful integrations. Microsoft 365 done right.",
		"og:title": "Powerful provisioning. Effortless intranets. | BindTuning",
		"og:description": "Effortless onboarding, simplified processes, and powerful integrations. Microsoft 365 done right.",
		"og:url": helpLinks.adminAppHome,
		"og:image" :helpLinks.socialPreviewImage,
		"og:image:secure_url": helpLinks.socialPreviewImage,
		"og:image:alt": "Don\'t get boxed in",
		"twitter:title": "Powerful provisioning. Effortless intranets. | BindTuning",
		"twitter:description": "Effortless onboarding, simplified processes, and powerful integrations. Microsoft 365 done right.",
		"twitter:image": helpLinks.socialPreviewImage,
	}),
	"catalog" : Object.assign(new Metadata(), {
		"title": "catalog Powerful provisioning. Effortless intranets. | BindTuning",
		"description": "Effortless onboarding, simplified processes, and powerful integrations. Microsoft 365 done right.",
		"og:title": "Powerful provisioning. Effortless intranets. | BindTuning",
		"og:description": "Effortless onboarding, simplified processes, and powerful integrations. Microsoft 365 done right.",
		"og:url": helpLinks.adminAppHome,
		"og:image" :helpLinks.socialPreviewImage,
		"og:image:secure_url": helpLinks.socialPreviewImage,
		"og:image:alt": "Don\'t get boxed in",
		"twitter:title": "Powerful provisioning. Effortless intranets. | BindTuning",
		"twitter:description": "Effortless onboarding, simplified processes, and powerful integrations. Microsoft 365 done right.",
		"twitter:image": helpLinks.socialPreviewImage
	}),
	"catalog-themes" : Object.assign(new Metadata(), {
		"title": "bt-theme Powerful provisioning. Effortless intranets. | BindTuning",
		"description": "Effortless onboarding, simplified processes, and powerful integrations. Microsoft 365 done right.",
		"og:title": "Powerful provisioning. Effortless intranets. | BindTuning",
		"og:description": "Effortless onboarding, simplified processes, and powerful integrations. Microsoft 365 done right.",
		"og:url": helpLinks.adminAppHome,
		"og:image" :helpLinks.socialPreviewImage,
		"og:image:secure_url": helpLinks.socialPreviewImage,
		"og:image:alt": "Don\'t get boxed in",
		"twitter:title": "Powerful provisioning. Effortless intranets. | BindTuning",
		"twitter:description": "Effortless onboarding, simplified processes, and powerful integrations. Microsoft 365 done right.",
		"twitter:image": helpLinks.socialPreviewImage
	}),
	"catalog-webparts" : Object.assign(new Metadata(), {
		"title": "bt-webpart Powerful provisioning. Effortless intranets. | BindTuning",
		"description": "Effortless onboarding, simplified processes, and powerful integrations. Microsoft 365 done right.",
		"og:title": "Powerful provisioning. Effortless intranets. | BindTuning",
		"og:description": "Effortless onboarding, simplified processes, and powerful integrations. Microsoft 365 done right.",
		"og:url": helpLinks.adminAppHome,
		"og:image" :helpLinks.socialPreviewImage,
		"og:image:secure_url": helpLinks.socialPreviewImage,
		"og:image:alt": "Don\'t get boxed in",
		"twitter:title": "Powerful provisioning. Effortless intranets. | BindTuning",
		"twitter:description": "Effortless onboarding, simplified processes, and powerful integrations. Microsoft 365 done right.",
		"twitter:image": helpLinks.socialPreviewImage
	}),
	"catalog-templates" : Object.assign(new Metadata(), {
		"title": "bt-template Powerful provisioning. Effortless intranets. | BindTuning",
		"description": "Effortless onboarding, simplified processes, and powerful integrations. Microsoft 365 done right.",
		"og:title": "Powerful provisioning. Effortless intranets. | BindTuning",
		"og:description": "Effortless onboarding, simplified processes, and powerful integrations. Microsoft 365 done right.",
		"og:url": helpLinks.adminAppHome,
		"og:image" :helpLinks.socialPreviewImage,
		"og:image:secure_url": helpLinks.socialPreviewImage,
		"og:image:alt": "Don\'t get boxed in",
		"twitter:title": "Powerful provisioning. Effortless intranets. | BindTuning",
		"twitter:description": "Effortless onboarding, simplified processes, and powerful integrations. Microsoft 365 done right.",
		"twitter:image": helpLinks.socialPreviewImage
	})
};
